import { Koppelingen } from '../translations-types';

const translations: Koppelingen = {
  selectSalon: 'Vestiging',
  selectSalonPlaceholder: 'Kies een vestiging',
  saved: 'Opgeslagen',
  googleCalendarOption: 'Google-agenda (Salonized)',
  goBookyOption: 'Google-agenda (GoBooky)',
  salonizedDeprecatedOption: 'Salonized (wordt uitgefaseerd)',
  leaveSalonizedTitle: 'Overstappen van Salonized?',
  leaveSalonizedContent:
    'De Salonized-koppeling wordt uitgefaseerd. Bij overstappen wordt Salonized ontkoppeld en kun je deze koppeling daarna niet opnieuw kiezen. Synchroniseer daarna de nieuwe koppeling, zodat de voorzorg/nazorg-status en adviezen van de afspraken worden overgezet.',
};

export default translations;
